import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  createFileRoute,
  useNavigate,
} from "@tanstack/react-router";
import { toast } from "sonner";

import { useTRPC } from "@/infrastructure/trpc/react";
import { SentryConnectionForm } from "@/sentry/components/sentry-connection-form";
import { AppLayout } from "@/shared/layout";

export const Route = createFileRoute(
  "/app/organization/$id/sentry/add"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: organizationId } = Route.useParams();
  const navigate = useNavigate();
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const createConnection = useMutation(
    trpc.sentry.create.mutationOptions({
      onSuccess: async () => {
        toast.success("Sentry connection created");
        await queryClient.invalidateQueries(
          trpc.sentry.list.queryOptions({
            organizationId,
          })
        );
        void navigate({
          to: "/app/organization/$id/settings/sentry",
          params: { id: organizationId },
        });
      },
      onError: (error) => {
        toast.error(
          error.message ?? "Failed to create connection"
        );
      },
    })
  );

  return (
    <AppLayout
      title="Add Sentry Connection"
      headerActions={null}
    >
      <div className="mx-auto max-w-2xl">
        <SentryConnectionForm
          organizationId={organizationId}
          mode="add"
          onSubmit={async (values) => {
            await createConnection.mutateAsync({
              organizationId,
              name: values.name,
              authToken: values.authToken,
              sentryOrganizationUrl:
                values.sentryOrganizationUrl,
            });
          }}
          isSubmitting={createConnection.isPending}
          cardDescription="Connect to your Sentry organization to monitor for new errors and regressions"
          submitButtonText="Add Connection"
          submittingButtonText="Adding..."
        />
      </div>
    </AppLayout>
  );
}
